import { useState, useEffect } from 'react';
import api from '../../../services/api';
import './AdminSlider.css';

const AdminSettings = () => {
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [activeTab, setActiveTab] = useState('general');
  const [newLink, setNewLink] = useState({ title: '', url: '' });

  useEffect(() => { fetchSettings(); }, []);

  const fetchSettings = async () => {
    try {
      setLoading(true);
      const res = await api.get('/api/settings');
      setSettings(res.data);
    } catch { setError('Ayarlar yüklenemedi.'); }
    finally { setLoading(false); }
  };

  const handleSave = async () => {
    setError(''); setSuccess('');
    try {
      const res = await api.put('/api/settings', settings);
      setSettings(res.data);
      setSuccess('Ayarlar kaydedildi.');
      setTimeout(() => setSuccess(''), 3000);
    } catch { setError('Kaydetme başarısız.'); }
  };

  const handleAddLink = () => {
    if (!newLink.title || !newLink.url) return;
    setSettings({ ...settings, footerLinks: [...(settings.footerLinks || []), newLink] });
    setNewLink({ title: '', url: '' });
  };

  const handleRemoveLink = (index) => {
    const links = [...settings.footerLinks];
    links.splice(index, 1);
    setSettings({ ...settings, footerLinks: links });
  };

  if (loading) return <div className="admin-slider-empty">Yükleniyor...</div>;
  if (!settings) return <div className="admin-slider-empty">Ayarlar yüklenemedi.</div>;

  return (
    <div className="admin-slider">
      {success && <div className="admin-slider-success">{success}</div>}
      {error && <div className="admin-slider-error">{error}</div>}

      {/* Tabs */}
      <div style={{ display: 'flex', gap: '0.5rem', marginBottom: '1.5rem' }}>
        <button onClick={() => setActiveTab('general')} style={{ padding: '0.5rem 1rem', borderRadius: '0.5rem', border: 'none', cursor: 'pointer', fontSize: '0.85rem', fontWeight: '500', backgroundColor: activeTab === 'general' ? '#2563eb' : '#374151', color: '#fff' }}>Genel</button>
        <button onClick={() => setActiveTab('footer')} style={{ padding: '0.5rem 1rem', borderRadius: '0.5rem', border: 'none', cursor: 'pointer', fontSize: '0.85rem', fontWeight: '500', backgroundColor: activeTab === 'footer' ? '#2563eb' : '#374151', color: '#fff' }}>Footer</button>
        <button onClick={() => setActiveTab('payment')} style={{ padding: '0.5rem 1rem', borderRadius: '0.5rem', border: 'none', cursor: 'pointer', fontSize: '0.85rem', fontWeight: '500', backgroundColor: activeTab === 'payment' ? '#2563eb' : '#374151', color: '#fff' }}>Ödeme</button>
        <button onClick={() => setActiveTab('donation')} style={{ padding: '0.5rem 1rem', borderRadius: '0.5rem', border: 'none', cursor: 'pointer', fontSize: '0.85rem', fontWeight: '500', backgroundColor: activeTab === 'donation' ? '#2563eb' : '#374151', color: '#fff' }}>Bağış</button>
      </div>

      {/* Genel Tab */}
      {activeTab === 'general' && (
        <div className="admin-slider-card">
          <div className="admin-slider-header"><h3>Site Ayarları</h3></div>
          <div style={{ padding: '1.5rem', display: 'flex', flexDirection: 'column', gap: '1rem' }}>
            <div className="admin-slider-form-group">
              <label>Site Adı</label>
              <input type="text" value={settings.siteName || ''} onChange={(e) => setSettings({ ...settings, siteName: e.target.value })} />
            </div>
            <div className="admin-slider-form-group">
              <label>Site Açıklaması</label>
              <textarea value={settings.siteDescription || ''} onChange={(e) => setSettings({ ...settings, siteDescription: e.target.value })} rows="2" style={{ width: '100%', padding: '0.5rem 0.75rem', backgroundColor: '#1f2937', border: '1px solid #4b5563', borderRadius: '0.375rem', color: '#fff', fontSize: '0.875rem', resize: 'vertical' }} />
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
              <div className="admin-slider-form-group">
                <label>Favicon URL</label>
                <input type="text" value={settings.favicon || ''} onChange={(e) => setSettings({ ...settings, favicon: e.target.value })} />
              </div>
              <div className="admin-slider-form-group">
                <label>Logo URL</label>
                <input type="text" value={settings.logo || ''} onChange={(e) => setSettings({ ...settings, logo: e.target.value })} />
              </div>
            </div>

            <h4 style={{ color: '#f3f4f6', fontSize: '0.95rem', margin: '0.5rem 0 0 0', paddingTop: '1rem', borderTop: '1px solid #374151' }}>SEO</h4>
            <div className="admin-slider-form-group">
              <label>Google Açıklaması (Meta Description)</label>
              <textarea value={settings.metaDescription || ''} onChange={(e) => setSettings({ ...settings, metaDescription: e.target.value })} rows="2" style={{ width: '100%', padding: '0.5rem 0.75rem', backgroundColor: '#1f2937', border: '1px solid #4b5563', borderRadius: '0.375rem', color: '#fff', fontSize: '0.875rem', resize: 'vertical' }} />
            </div>
            <div className="admin-slider-form-group">
              <label>Anahtar Kelimeler (virgülle ayırın)</label>
              <input type="text" value={settings.metaKeywords || ''} onChange={(e) => setSettings({ ...settings, metaKeywords: e.target.value })} placeholder="zaman çizelgesi, tarih, türk tarihi" />
            </div>

            <h4 style={{ color: '#f3f4f6', fontSize: '0.95rem', margin: '0.5rem 0 0 0', paddingTop: '1rem', borderTop: '1px solid #374151' }}>İletişim</h4>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
              <div className="admin-slider-form-group">
                <label>E-posta</label>
                <input type="email" value={settings.email || ''} onChange={(e) => setSettings({ ...settings, email: e.target.value })} />
              </div>
              <div className="admin-slider-form-group">
                <label>Telefon</label>
                <input type="text" value={settings.phone || ''} onChange={(e) => setSettings({ ...settings, phone: e.target.value })} />
              </div>
            </div>
            <div className="admin-slider-form-group">
              <label>Adres</label>
              <input type="text" value={settings.address || ''} onChange={(e) => setSettings({ ...settings, address: e.target.value })} />
            </div>

            <h4 style={{ color: '#f3f4f6', fontSize: '0.95rem', margin: '0.5rem 0 0 0', paddingTop: '1rem', borderTop: '1px solid #374151' }}>Sosyal Medya</h4>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
              <div className="admin-slider-form-group">
                <label>Twitter / X</label>
                <input type="text" value={settings.socialMedia?.twitter || ''} onChange={(e) => setSettings({ ...settings, socialMedia: { ...settings.socialMedia, twitter: e.target.value } })} placeholder="https://twitter.com/..." />
              </div>
              <div className="admin-slider-form-group">
                <label>YouTube</label>
                <input type="text" value={settings.socialMedia?.youtube || ''} onChange={(e) => setSettings({ ...settings, socialMedia: { ...settings.socialMedia, youtube: e.target.value } })} placeholder="https://youtube.com/..." />
              </div>
              <div className="admin-slider-form-group">
                <label>Instagram</label>
                <input type="text" value={settings.socialMedia?.instagram || ''} onChange={(e) => setSettings({ ...settings, socialMedia: { ...settings.socialMedia, instagram: e.target.value } })} placeholder="https://instagram.com/..." />
              </div>
              <div className="admin-slider-form-group">
                <label>Facebook</label>
                <input type="text" value={settings.socialMedia?.facebook || ''} onChange={(e) => setSettings({ ...settings, socialMedia: { ...settings.socialMedia, facebook: e.target.value } })} placeholder="https://facebook.com/..." />
              </div>
              <div className="admin-slider-form-group">
                <label>LinkedIn</label>
                <input type="text" value={settings.socialMedia?.linkedin || ''} onChange={(e) => setSettings({ ...settings, socialMedia: { ...settings.socialMedia, linkedin: e.target.value } })} placeholder="https://linkedin.com/..." />
              </div>
            </div>

            <button onClick={handleSave} className="admin-slider-add-btn" style={{ alignSelf: 'flex-start', marginTop: '1rem' }}>Kaydet</button>
          </div>
        </div>
      )}

      {/* Footer Tab */}
      {activeTab === 'footer' && (
        <div className="admin-slider-card">
          <div className="admin-slider-header"><h3>Footer Ayarları</h3></div>
          <div style={{ padding: '1.5rem', display: 'flex', flexDirection: 'column', gap: '1rem' }}>
            <div className="admin-slider-form-group">
              <label>Footer Açıklama Metni</label>
              <textarea value={settings.footerText || ''} onChange={(e) => setSettings({ ...settings, footerText: e.target.value })} rows="3" style={{ width: '100%', padding: '0.5rem 0.75rem', backgroundColor: '#1f2937', border: '1px solid #4b5563', borderRadius: '0.375rem', color: '#fff', fontSize: '0.875rem', resize: 'vertical' }} />
            </div>
            <div className="admin-slider-form-group">
              <label>Copyright Metni</label>
              <input type="text" value={settings.copyrightText || ''} onChange={(e) => setSettings({ ...settings, copyrightText: e.target.value })} placeholder="© {year} Site Adı. Tüm hakları saklıdır." />
              <p style={{ fontSize: '0.7rem', color: '#6b7280', marginTop: '0.25rem' }}>{'{year}'} otomatik olarak güncel yıl ile değiştirilir.</p>
            </div>

            <h4 style={{ color: '#f3f4f6', fontSize: '0.95rem', margin: '0.5rem 0 0 0', paddingTop: '1rem', borderTop: '1px solid #374151' }}>Footer Menüleri</h4>
            <p style={{ fontSize: '0.75rem', color: '#9ca3af', margin: 0 }}>Her menü bir sütun olarak footer'da görünür. Menü ekleyin, altına linkler ekleyin.</p>

            {/* Mevcut menüler */}
            {(settings.footerMenus || []).map((menu, menuIndex) => (
              <div key={menuIndex} style={{ padding: '1rem', backgroundColor: '#1f2937', borderRadius: '0.5rem', border: '1px solid #374151' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.75rem' }}>
                  <input
                    type="text"
                    value={menu.title}
                    onChange={(e) => {
                      const menus = [...settings.footerMenus];
                      menus[menuIndex].title = e.target.value;
                      setSettings({ ...settings, footerMenus: menus });
                    }}
                    placeholder="Menü Başlığı"
                    style={{ padding: '0.4rem 0.6rem', backgroundColor: '#374151', border: '1px solid #4b5563', borderRadius: '0.375rem', color: '#fff', fontSize: '0.85rem', fontWeight: '600' }}
                  />
                  <button onClick={() => {
                    const menus = [...settings.footerMenus];
                    menus.splice(menuIndex, 1);
                    setSettings({ ...settings, footerMenus: menus });
                  }} style={{ background: 'none', border: 'none', color: '#f87171', cursor: 'pointer', fontSize: '0.8rem' }}>Menüyü Sil</button>
                </div>

                {/* Menü linkleri */}
                {(menu.links || []).map((link, linkIndex) => (
                  <div key={linkIndex} style={{ display: 'flex', gap: '0.5rem', alignItems: 'center', marginBottom: '0.4rem' }}>
                    <input
                      type="text"
                      value={link.label}
                      onChange={(e) => {
                        const menus = [...settings.footerMenus];
                        menus[menuIndex].links[linkIndex].label = e.target.value;
                        setSettings({ ...settings, footerMenus: menus });
                      }}
                      placeholder="Link adı"
                      style={{ flex: 1, padding: '0.3rem 0.5rem', backgroundColor: '#374151', border: '1px solid #4b5563', borderRadius: '0.25rem', color: '#d1d5db', fontSize: '0.8rem' }}
                    />
                    <input
                      type="text"
                      value={link.url}
                      onChange={(e) => {
                        const menus = [...settings.footerMenus];
                        menus[menuIndex].links[linkIndex].url = e.target.value;
                        setSettings({ ...settings, footerMenus: menus });
                      }}
                      placeholder="/sayfa veya https://..."
                      style={{ flex: 1, padding: '0.3rem 0.5rem', backgroundColor: '#374151', border: '1px solid #4b5563', borderRadius: '0.25rem', color: '#d1d5db', fontSize: '0.8rem' }}
                    />
                    <button onClick={() => {
                      const menus = [...settings.footerMenus];
                      menus[menuIndex].links.splice(linkIndex, 1);
                      setSettings({ ...settings, footerMenus: menus });
                    }} style={{ background: 'none', border: 'none', color: '#f87171', cursor: 'pointer', fontSize: '1rem' }}>&times;</button>
                  </div>
                ))}

                <button onClick={() => {
                  const menus = [...settings.footerMenus];
                  menus[menuIndex].links = [...(menus[menuIndex].links || []), { label: '', url: '' }];
                  setSettings({ ...settings, footerMenus: menus });
                }} style={{ marginTop: '0.5rem', padding: '0.3rem 0.6rem', backgroundColor: '#374151', border: '1px solid #4b5563', borderRadius: '0.25rem', color: '#60a5fa', cursor: 'pointer', fontSize: '0.75rem' }}>+ Link Ekle</button>
              </div>
            ))}

            <button onClick={() => {
              const menus = [...(settings.footerMenus || []), { title: 'Yeni Menü', links: [] }];
              setSettings({ ...settings, footerMenus: menus });
            }} style={{ padding: '0.5rem 1rem', backgroundColor: '#059669', color: '#fff', border: 'none', borderRadius: '0.375rem', fontSize: '0.8rem', cursor: 'pointer', alignSelf: 'flex-start' }}>+ Yeni Menü Ekle</button>

            <button onClick={handleSave} className="admin-slider-add-btn" style={{ alignSelf: 'flex-start', marginTop: '1rem' }}>Kaydet</button>
          </div>
        </div>
      )}

      {/* Ödeme Tab */}
      {activeTab === 'payment' && (
        <div className="admin-slider-card">
          <div className="admin-slider-header"><h3>Ödeme Ayarları</h3></div>
          <div style={{ padding: '1.5rem', display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>

            {/* iyzico */}
            <div style={{ padding: '1rem', backgroundColor: '#1f2937', borderRadius: '0.5rem' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
                <h4 style={{ color: '#f3f4f6', fontSize: '0.95rem', margin: 0 }}>iyzico</h4>
                <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', cursor: 'pointer' }}>
                  <input type="checkbox" checked={settings.payment?.iyzicoEnabled || false} onChange={(e) => setSettings({ ...settings, payment: { ...settings.payment, iyzicoEnabled: e.target.checked } })} style={{ accentColor: '#2563eb' }} />
                  <span style={{ fontSize: '0.8rem', color: '#d1d5db' }}>Aktif</span>
                </label>
              </div>
              {settings.payment?.iyzicoEnabled && (
                <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
                  <div className="admin-slider-form-group"><label>API Key</label><input type="text" value={settings.payment?.iyzicoApiKey || ''} onChange={(e) => setSettings({ ...settings, payment: { ...settings.payment, iyzicoApiKey: e.target.value } })} /></div>
                  <div className="admin-slider-form-group"><label>Secret Key</label><input type="password" value={settings.payment?.iyzicoSecretKey || ''} onChange={(e) => setSettings({ ...settings, payment: { ...settings.payment, iyzicoSecretKey: e.target.value } })} /></div>
                  <div className="admin-slider-form-group"><label>Base URL</label><input type="text" value={settings.payment?.iyzicoBaseUrl || 'https://sandbox-api.iyzipay.com'} onChange={(e) => setSettings({ ...settings, payment: { ...settings.payment, iyzicoBaseUrl: e.target.value } })} /><p style={{ fontSize: '0.7rem', color: '#6b7280', marginTop: '0.2rem' }}>Canlı: https://api.iyzipay.com | Test: https://sandbox-api.iyzipay.com</p></div>
                </div>
              )}
            </div>

            {/* PayTR */}
            <div style={{ padding: '1rem', backgroundColor: '#1f2937', borderRadius: '0.5rem' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
                <h4 style={{ color: '#f3f4f6', fontSize: '0.95rem', margin: 0 }}>PayTR</h4>
                <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', cursor: 'pointer' }}>
                  <input type="checkbox" checked={settings.payment?.paytrEnabled || false} onChange={(e) => setSettings({ ...settings, payment: { ...settings.payment, paytrEnabled: e.target.checked } })} style={{ accentColor: '#2563eb' }} />
                  <span style={{ fontSize: '0.8rem', color: '#d1d5db' }}>Aktif</span>
                </label>
              </div>
              {settings.payment?.paytrEnabled && (
                <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
                  <div className="admin-slider-form-group"><label>Merchant ID</label><input type="text" value={settings.payment?.paytrMerchantId || ''} onChange={(e) => setSettings({ ...settings, payment: { ...settings.payment, paytrMerchantId: e.target.value } })} /></div>
                  <div className="admin-slider-form-group"><label>Merchant Key</label><input type="password" value={settings.payment?.paytrMerchantKey || ''} onChange={(e) => setSettings({ ...settings, payment: { ...settings.payment, paytrMerchantKey: e.target.value } })} /></div>
                  <div className="admin-slider-form-group"><label>Merchant Salt</label><input type="password" value={settings.payment?.paytrMerchantSalt || ''} onChange={(e) => setSettings({ ...settings, payment: { ...settings.payment, paytrMerchantSalt: e.target.value } })} /></div>
                </div>
              )}
            </div>

            {/* EFT / Havale */}
            <div style={{ padding: '1rem', backgroundColor: '#1f2937', borderRadius: '0.5rem' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
                <h4 style={{ color: '#f3f4f6', fontSize: '0.95rem', margin: 0 }}>EFT / Havale</h4>
                <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', cursor: 'pointer' }}>
                  <input type="checkbox" checked={settings.payment?.eftEnabled || false} onChange={(e) => setSettings({ ...settings, payment: { ...settings.payment, eftEnabled: e.target.checked } })} style={{ accentColor: '#2563eb' }} />
                  <span style={{ fontSize: '0.8rem', color: '#d1d5db' }}>Aktif</span>
                </label>
              </div>
              {settings.payment?.eftEnabled && (
                <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
                  <div className="admin-slider-form-group"><label>Banka Adı</label><input type="text" value={settings.payment?.eftBankName || ''} onChange={(e) => setSettings({ ...settings, payment: { ...settings.payment, eftBankName: e.target.value } })} /></div>
                  <div className="admin-slider-form-group"><label>Hesap Sahibi</label><input type="text" value={settings.payment?.eftAccountHolder || ''} onChange={(e) => setSettings({ ...settings, payment: { ...settings.payment, eftAccountHolder: e.target.value } })} /></div>
                  <div className="admin-slider-form-group"><label>IBAN</label><input type="text" value={settings.payment?.eftIban || ''} onChange={(e) => setSettings({ ...settings, payment: { ...settings.payment, eftIban: e.target.value } })} placeholder="TR00 0000 0000 0000 0000 0000 00" /></div>
                  <div className="admin-slider-form-group"><label>Açıklama</label><textarea value={settings.payment?.eftDescription || ''} onChange={(e) => setSettings({ ...settings, payment: { ...settings.payment, eftDescription: e.target.value } })} rows="2" style={{ width: '100%', padding: '0.5rem 0.75rem', backgroundColor: '#374151', border: '1px solid #4b5563', borderRadius: '0.375rem', color: '#fff', fontSize: '0.875rem', resize: 'vertical' }} /></div>
                </div>
              )}
            </div>

            <button onClick={handleSave} className="admin-slider-add-btn" style={{ alignSelf: 'flex-start' }}>Kaydet</button>
          </div>
        </div>
      )}

      {/* Bağış Tab */}
      {activeTab === 'donation' && (
        <div className="admin-slider-card">
          <div className="admin-slider-header"><h3>Bağış Ayarları</h3></div>
          <div style={{ padding: '1.5rem', display: 'flex', flexDirection: 'column', gap: '1rem' }}>
            <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', cursor: 'pointer' }}>
              <input type="checkbox" checked={settings.donation?.enabled || false} onChange={(e) => setSettings({ ...settings, donation: { ...settings.donation, enabled: e.target.checked } })} style={{ accentColor: '#2563eb' }} />
              <span style={{ fontSize: '0.9rem', color: '#f3f4f6', fontWeight: '600' }}>Bağış Modülü Aktif</span>
            </label>

            {settings.donation?.enabled && (
              <>
                <div className="admin-slider-form-group"><label>Başlık</label><input type="text" value={settings.donation?.title || ''} onChange={(e) => setSettings({ ...settings, donation: { ...settings.donation, title: e.target.value } })} /></div>
                <div className="admin-slider-form-group"><label>Açıklama</label><textarea value={settings.donation?.description || ''} onChange={(e) => setSettings({ ...settings, donation: { ...settings.donation, description: e.target.value } })} rows="2" style={{ width: '100%', padding: '0.5rem 0.75rem', backgroundColor: '#1f2937', border: '1px solid #4b5563', borderRadius: '0.375rem', color: '#fff', fontSize: '0.875rem', resize: 'vertical' }} /></div>
                <div className="admin-slider-form-group">
                  <label>Hazır Tutarlar (virgülle ayırın, TL)</label>
                  <input
                    type="text"
                    defaultValue={(settings.donation?.amounts || [10, 25, 50, 100, 250, 500]).join(', ')}
                    onBlur={(e) => setSettings({ ...settings, donation: { ...settings.donation, amounts: e.target.value.split(',').map(v => parseInt(v.trim())).filter(v => !isNaN(v) && v > 0) } })}
                    placeholder="10, 25, 50, 100, 250, 500"
                  />
                  <p style={{ fontSize: '0.7rem', color: '#6b7280', marginTop: '0.25rem' }}>Örnek: 10, 25, 50, 100, 250, 500 — alandan çıkınca kaydedilir</p>
                </div>
                <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', cursor: 'pointer' }}>
                  <input type="checkbox" checked={settings.donation?.customAmount !== false} onChange={(e) => setSettings({ ...settings, donation: { ...settings.donation, customAmount: e.target.checked } })} style={{ accentColor: '#2563eb' }} />
                  <span style={{ fontSize: '0.85rem', color: '#d1d5db' }}>Özel tutar girişine izin ver</span>
                </label>
              </>
            )}

            <button onClick={handleSave} className="admin-slider-add-btn" style={{ alignSelf: 'flex-start', marginTop: '0.5rem' }}>Kaydet</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminSettings;
